module.exports = __webpack_public_path__ + "img/dislike-1.4d189acf.svg";